import React, { useState } from 'react';
import { Button, Badge, Group, Tooltip } from '@mantine/core';
import { IconNfc, IconNfcOff } from '@tabler/icons-react';
import { useNFC } from '../../../features/nfc/contexts/NFCContext';
import { showNotification } from '@mantine/notifications';

/**
 * Android端末用NFCスキャンボタン
 * Androidデバイスでのみ表示され、手動でNFCスキャンを開始します
 */
export const AndroidNFCScanButton: React.FC = () => {
  const { platform, isConnected, needsManualScan, startManualScan } = useNFC();
  const [isScanning, setIsScanning] = useState(false);
  const [scanStarted, setScanStarted] = useState(false);

  // Android以外、または手動スキャンが不要な場合は表示しない
  if (!platform.isAndroid || !needsManualScan) {
    return null;
  }

  const handleStartScan = async () => {
    try {
      setIsScanning(true);
      console.log('Starting manual NFC scan...');
      
      // NFCContextのstartManualScanを使用
      await startManualScan();
      setScanStarted(true);
    } catch (error: any) {
      console.error('Failed to start NFC scan:', error);
      
      let errorMessage = 'NFCスキャンの開始に失敗しました';
      
      if (error.name === 'NotAllowedError') {
        errorMessage = 'NFC権限が拒否されました。ブラウザの設定でNFCを許可してください。';
      } else if (error.message?.includes('HTTPS')) {
        errorMessage = 'HTTPS接続が必要です';
      } else if (error.message?.includes('not available')) {
        errorMessage = 'このブラウザはWeb NFC APIに対応していません。ChromeまたはEdgeを使用してください。';
      }
      
      showNotification({
        title: 'エラー',
        message: errorMessage,
        color: 'red',
        icon: <IconNfcOff />,
        autoClose: false,
      });
    } finally {
      setIsScanning(false);
    }
  };

  return (
    <Group position="center" style={{ 
      position: 'fixed', 
      bottom: 20, 
      right: 20,
      zIndex: 9999 
    }}>
      {!scanStarted ? (
        <Tooltip label="NFCカードを読み取るにはタップしてください" position="left">
          <Button
            size="lg"
            radius="xl"
            onClick={handleStartScan}
            loading={isScanning}
            leftIcon={<IconNfc size={24} />}
            style={{
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            }}
          >
            NFCスキャン
          </Button>
        </Tooltip>
      ) : (
        <Badge
          size="lg"
          radius="xl"
          color="green"
          leftSection={<IconNfc size={20} />}
          style={{
            padding: '12px 20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
        >
          NFCスキャン中...
        </Badge>
      )}
    </Group>
  );
};